// Masonry Layout.
// https://github.com/bigbite/macy.js
import Macy from 'macy';

export function masonryInit() {
	const grid = document.querySelector('.masonry-layout__inner');

	if (grid) {
		const masonry = Macy({
			container: '.masonry-layout__inner',
			trueOrder: false,
			waitForImages: true,
			margin: 10,
			columns: 1,
			mobileFirst: true,
			breakAt: {
				768: 2,
				1280: 3,
			},
		});

		// Recalculate when all images are loaded.
		masonry.recalculate(true, true);
		masonry.runOnImageLoad(function () {
			masonry.recalculate(true);
		}, true);

		/**
		 * When append events are triggered on the document, attempt
		 * to find any children within the event, append them to the Macy instance,
		 * and then recalculate the layout.
		 */
		document.addEventListener('mkdoAjaxAppend', function (event) {
			if (!event.detail.items) {
				return;
			}

			for (let item of event.detail.items) {
				grid.appendChild(item);
			}

			masonry.recalculate(true, true);
			masonry.runOnImageLoad(function () {
				masonry.recalculate(true);
			}, true);
		});

		document.addEventListener('mkdoSearchAjaxAppend', function (event) {
			if (!event.detail.items) {
				return;
			}

			for (let item of event.detail.items) {
				grid.appendChild(item);
			}

			masonry.recalculate(true, true);
			masonry.runOnImageLoad(function () {
				masonry.recalculate(true);
			}, true);
		});

		/**
		 * When the "mkdoBlogFilter" event is triggered on the document, attempt
		 * to identify the category passed and then filter any items currently
		 * in the grid by the slug.
		 */
		let hiddenItems = null;

		document.addEventListener('mkdoBlogFilter', function (event) {
			if (!event.detail.hasOwnProperty('category')) {
				return;
			}

			const category = event.detail.category;

			if (null !== hiddenItems) {
				for (let item of hiddenItems) {
					item.style.display = 'block';
				}
			}

			if (category !== '*') {
				const items = grid.childNodes;

				if (!items) {
					return;
				}

				hiddenItems = [];

				for (let item of items) {
					let data = item.dataset || false;

					if (!data) {
						continue;
					}

					if (
						false === data ||
						!data.hasOwnProperty('category') ||
						category !== data.category
					) {
						hiddenItems.push(item);
						item.style.display = 'none';
					}
				}
			}

			masonry.recalculate(true, true);
			masonry.runOnImageLoad(function () {
				masonry.recalculate(true);
			}, true);
		});
	}
}
